import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { Panel, PanelLabel } from "@/components/PageHeader";
import type { DashboardResponse } from "@/lib/dashboard";
import { monthLabel, money } from "@/lib/format";

const FREQ = { quarterly: "Trimestral", semiannual: "Semestral", annual: "Anual" };

export function BigPaymentsCard({ d }: { d: DashboardResponse }) {
  const list = d.big_payments ?? [];
  if (!list.length) return null;
  const total = list.reduce((s, p) => s + p.amount, 0);
  const perMonth = list.reduce((s, p) => s + p.monthly_save, 0);
  return (
    <Panel testId="big-payments-card">
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          <PanelLabel>Próximos pagos grandes</PanelLabel>
          <p className="mt-1 text-sm text-slate-500">Pagos trimestrales y anuales de los próximos 3 meses.</p>
        </div>
        <div className="text-right">
          <p className="tabular font-display text-xl font-bold text-[#1B2A4A]" data-testid="big-payments-total">{money(total)}</p>
          <p className="tabular text-xs text-slate-500" data-testid="big-payments-per-month">Aparta {money(perMonth)} este mes</p>
        </div>
      </div>
      <ul className="divide-y divide-[#DDE1E8]">
        {list.map((p) => (
          <li key={`${p.item_id}-${p.month}`} className="grid grid-cols-[auto_1fr_auto] items-center gap-3 py-3 text-sm" data-testid={`big-payment-${p.item_id}-${p.month}`}>
            <CalendarClock className="h-4 w-4 text-[#C9A84C]" />
            <span className="min-w-0">
              <span className="block break-words font-semibold text-[#1B2A4A]">{p.name} <span className="font-normal text-slate-400">· {FREQ[p.frequency]}</span></span>
              <span className="text-xs capitalize text-slate-500">{monthLabel(p.month)}</span>
            </span>
            <span className="text-right">
              <span className="tabular block font-semibold text-[#1B2A4A]">{money(p.amount)}</span>
              <span className="tabular text-xs text-slate-500" data-testid={`big-payment-save-${p.item_id}-${p.month}`}>aparta {money(p.monthly_save)} al mes</span>
            </span>
          </li>
        ))}
      </ul>
      <Link to="/presupuesto" className="mt-3 inline-block text-sm font-semibold text-[#1B2A4A] underline-offset-4 hover:underline" data-testid="big-payments-link">Ver presupuesto</Link>
    </Panel>
  );
}
